import React from "react";
import { toEmbedUrl } from "../lib/embed";
import { Tv } from "lucide-react";

export function LiveStream({ url, compact = false }) {
  const embed = toEmbedUrl(url);
  if (!embed) return null;
  return (
    <div data-testid="live-stream" className={`relative w-full overflow-hidden rounded-2xl bg-black border border-white/10 ${compact ? "" : "shadow-[0_0_40px_-10px_rgba(255,0,127,0.4)]"}`}
         style={{ aspectRatio: "16 / 9" }}>
      <iframe
        data-testid="live-stream-iframe"
        src={embed}
        title="Livestream"
        className="absolute inset-0 w-full h-full"
        allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
      />
      <div className="pointer-events-none absolute top-2 left-2 inline-flex items-center gap-1.5 px-2 py-1 rounded-full bg-black/60 border border-[#FF1744]/50 text-[#FF1744] text-[10px] uppercase tracking-[0.25em]">
        <Tv className="w-3 h-3" /> Live
      </div>
    </div>
  );
}
